// Material UI
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      '& > *': {
        margin: theme.spacing(2, 1),
        padding: theme.spacing(4, 4, 1),
        width: '100%',
        height: 'auto',
        [theme.breakpoints.down('xs')]: {
          padding: theme.spacing(4, 2, 1),
        },
      },
    },
    boxTop: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      '& > *': {
        marginRight: theme.spacing(2),
      },
    },
    advancedFilters:{
      padding: theme.spacing(1, 0),
      '& .MuiFormControl-root': {
        minWidth: '180px',
        marginRight: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
          minWidth: '100%',
        },
      },
      '& .MuiFormControlLabel-root': {
        marginTop: theme.spacing(2),
        marginRight: theme.spacing(4),
        [theme.breakpoints.down('xs')]: {
          minWidth: '46%',
          marginRight: theme.spacing(2),
        },
      }
    },
    boxForm: {
      '& > *': {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        width: '100%'
      },
    },
    fieldFirst: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.down('xs')]: {
        marginRight: 0,
      },
    },
    buttons: {
      display: 'flex',
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    buttonsLast: {
      marginRight: 0
    }
  }),
);

export default useStyles;
